// extracted by mini-css-extract-plugin
export default {"page":"MyAccountPage_page__60W-u","tabs":"MyAccountPage_tabs__1Rgal","tab":"MyAccountPage_tab__S7mgw","tabContainer":"MyAccountPage_tabContainer__1CqJU"};